export enum StepId {
  LandingPage = 'LANDING_PAGE',
  SelectCategory = 'SELECT_CATEGORY',
  SelectProducts = 'SELECT_PRODUCTS',
  SelectImage = 'SELECT_IMAGE',
  SelectName = 'SELECT_NAME',
  StoreSetup = 'STORE_SETUP',
  StoreReady = 'STORE_READY',
}

export enum ActionId {
  RedirectToLogin = 'REDIRECT_TO_LOGIN',
  CreateMetaSite = 'CREATE_META_SITE',
  RedirectToConnectPrintful = 'REDIRECT_TO_CONNECT_PRINTFUL',
  InstallSiteApps = 'INSTALL_SITE_APPS',
  RedirectToUpgradePlan = 'REDIRECT_TO_UPGRADE_PLAN',
  AddStoreProducts = 'ADD_STORE_PRODUCTS',
}
